import { mapToProjectLink, mapToQuickLink } from '../../helpers/GlobalMapper';
const API_URL = `${process.env.REACT_APP_API_URL}`;

export const fetchQuickLinks = async (accessToken: string, tenantID: number) => {
  try {
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_QUICKLINK_API}?tenantId=${tenantID}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch users.");
    }

    const data = await response.json();
    console.log("Normal data:::", data)
    const mappedData = mapToProjectLink(data);
    console.log("mappedData data:::", mappedData)
    return mappedData;

  } catch (error) {
    throw error;
  }
};

export const addQuickLink = async (quickLink: any, accessToken: string, tenantID: number) => {
  try {
    
    const response = await fetch(`${API_URL}${process.env.REACT_APP_QUICKLINK_ADD_API}?tenantId=${tenantID}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(quickLink),
    });

    if (!response.ok) {
      throw new Error("Failed to add quick link.");
    }

    const text = await response.text();
    try {
      return JSON.parse(text); // Return parsed JSON if valid
    } catch {
      console.warn("Server response is not valid JSON:", text);
      return text; // Return plain text as fallback
    }
  } catch (error) {
    throw error;
  }
};

export const updateQuickLink = async (quickLink: any, accessToken: string, tenantID: number) => {
  try {
    const response = await fetch(
      `${API_URL}${[process.env.REACT_APP_QUICKLINK_UPDATE_API]}?tenantId=${tenantID}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(quickLink),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to update quick link.");
    }

    const text = await response.text();
    try {
      return JSON.parse(text); // Return parsed JSON if valid
    } catch {
      console.warn("Server response is not valid JSON:", text);
      return text; // Return plain text as fallback
    }
  } catch (error) {
    throw error;
  }
};

export const deleteQuickLink = async (
  quickLinkId: string,
  accessToken: string,
  tenantID: number,
  deletedBy: number
) => {
  const apiUrl = `${API_URL}${process.env.REACT_APP_QUICKLINK_DELETE_API}?quickLinkId=${encodeURIComponent(quickLinkId)}&tenantId=${tenantID}&deletedBy=${deletedBy}`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to delete QuickLink. Status: ${response.statusText}`
      );
    }

    return true; // Indicate success
  } catch (error) {
    console.error("Error deleting QuickLink:", error);
    throw error; // Propagate error to be handled by the caller
  }
};
